import NFT_ABI from '../assets/json/ABI.json';
import TOKEN_ABI from '../assets/json/TOKEN_ABI.json';
import MULTI_CALL_ABI from '../assets/json/MULTICALL_ABI.json';
import STAKING_ABI from '../assets/json/STAKING_ABI.json';

export const addresses: any = {
    'CactiNFT': {
        1: {
            'address': '',
            'abi': NFT_ABI
        },
        4: {
            'address': '',
            'abi': NFT_ABI
        },
        56: { // mainnet
            'address': '0x9432e72f68614fFdD3BA82616AC59e878284Aac4',
            'abi': NFT_ABI
        },
        97: { // testnet
            'address': '0x4d05196cc13d38c8cc172a11246c03ccef28c8ac',
            'abi': NFT_ABI
        }
    },
    'MultiCall': {
        1: {
            'address': '',
            'abi': MULTI_CALL_ABI
        },
        4: {
            'address': '',
            'abi': MULTI_CALL_ABI
        },
        56: { // mainnet
            'address': '0xfF6FD90A470Aaa0c1B8A54681746b07AcdFedc9B',
            'abi': MULTI_CALL_ABI
        },
        97: { // testnet
            'address': '0x8F3273Fb89B075b1645095ABaC6ed17B2d4Bc576',
            'abi': MULTI_CALL_ABI
        }
    },
    'CactiToken': {
        1: {
            'address': '',
            'abi': TOKEN_ABI
        },
        4: {
            'address': '',
            'abi': TOKEN_ABI
        },
        56: { // mainnet
            'address': '0x35482D03A807aBDf5B25f277bFE744A4E2fb19a2',
            'abi': TOKEN_ABI
        },
        97: { // testnet
            'address': '0xeb363c4596f9a758d8e1e311a812cd6e75015a6d',
            'abi': TOKEN_ABI
        }
    },
    'CactiNFTStaking': {
        1: {
            'address': '',
            'abi': STAKING_ABI
        },
        4: {
            'address': '',
            'abi': STAKING_ABI
        },
        56: { // mainnet
            'address': '0xbB780090204e02302083c4B39a540d40eB16A7Bf',
            'abi': STAKING_ABI
        },
        97: { // testnet
            'address': '0x3e2873b793BE5E109dc043Fa6087E561ADb6a70d',
            'abi': STAKING_ABI
        }
    }
}